import type { ReactElement } from 'react'

type Props = {
  steps: Array<ReactElement>
}

const Stepper = ({ steps }: Props) => {
  return (
    <div className="flex flex-row">
      {steps &&
        steps.map((step, index) => (
          <div className={`${index > 0 ? 'ml-[30px]' : ''}`} key={index}>
            {step}
          </div>
        ))}
    </div>
  )
}

export default Stepper
